import { QueryClient } from '@tanstack/react-query';

/** Shared TanStack Query client — see docs/migrations/03-tanstack-query-zustand.md */
export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
